import Status from './status';

export default class UploadFile {
  file;
  status;
  url;

  constructor(file) {
    this.file = file;
    this.status = Status.Uploading;
    this.url = undefined;
  }

  static instanceOf(file) {
    return file !== undefined ? new UploadFile(file) : undefined;
  }

  done() {
    this.status = Status.Done;
  }

  loadUrl(url) {
    this.url = url;
  }

  isStillUploading() {
    return this.status === Status.Uploading;
  }
}
